// packages/web/src/components/ui/Copyable.tsx — misma API. Botón con texto "Copiar/Copiado" (no solo icono)
// y anuncio para lectores de pantalla.
import { useState } from 'react';
import { Check, Copy } from 'lucide-react';

interface Props { value: string; title?: string; className?: string }

export function Copyable({ value, title, className = '' }: Props) {
  const [copied, setCopied] = useState(false);
  async function handleCopy(): Promise<void> {
    try { await navigator.clipboard.writeText(value); setCopied(true); window.setTimeout(() => setCopied(false), 1500); }
    catch { /* sin clipboard: el usuario puede seleccionar el texto */ }
  }
  return (
    <div className={`flex min-w-0 max-w-full items-center gap-2 rounded-lg border border-slate-200 bg-slate-50 pl-3 pr-1 py-1 ${className}`}>
      <span className="min-w-0 truncate font-mono text-[13px] text-slate-700 flex-1 select-all" title={title ?? value}>{value}</span>
      <button type="button" onClick={() => void handleCopy()}
        className={`inline-flex items-center gap-1 rounded-md px-2 py-1.5 text-xs font-semibold shrink-0 ${copied ? 'text-emerald-800' : 'text-marzano-600 hover:bg-white'} focus-visible:outline focus-visible:outline-[3px] focus-visible:outline-amber-500`}>
        {copied ? <Check aria-hidden className="w-4 h-4" /> : <Copy aria-hidden className="w-4 h-4" />}
        <span aria-live="polite">{copied ? 'Copiado' : 'Copiar'}</span>
      </button>
    </div>
  );
}
